import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hotel-list-item-review__ratings" }
const _hoisted_2 = { class: "hotel-list-item-review__rating" }
const _hoisted_3 = { class: "hotel-list-item-review__percentage" }
const _hoisted_4 = { class: "hotel-list-item-review__description" }
const _hoisted_5 = { class: "hotel-list-item-review__rating-count" }

import type { ItemType } from '@/interfaces/hotel-list-types/hotel-list-types';
import { pluralize, ratingText } from '@/js/utils/utils';
import { numberFormat } from '@/js/utils/numberUtils';
import { computed } from 'vue';
import { ratingOverall } from '@/js/utils/utils';

type Props = {
	review: Pick<ItemType, 'Ratings' | 'NumberOfRatings'>;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'HotelListItemReview',
  props: {
    review: {}
  },
  setup(__props: any) {



const ratingDescription = ratingText(__props.review.Ratings.Overall);

const ratingCount = computed(() => `${pluralize(__props.review.NumberOfRatings, 'Bewertung', 'Bewertungen')}`);

const overallRating = ratingOverall(__props.review.Ratings.Overall);

const recommendationRate = computed(() => numberFormat(__props.review.Ratings.RecommendationRate ?? 0, 0));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hotel-list-item-review", { 'hotel-list-item-review--no-description': _unref(ratingDescription) === '' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(overallRating)), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_3, _toDisplayString(recommendationRate.value) + "%", 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(ratingDescription)), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_5, _toDisplayString(ratingCount.value), 1 /* TEXT */),
      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "hotel-list-item-review__recommendation-rate" }, "Weiterempfehlungsrate", -1 /* HOISTED */))
    ])
  ], 2 /* CLASS */))
}
}

})